export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  isDetailed: false,
  stickeyHeaders: true,
  rearrangeCols: false,
  permissionModule: 'scm',
  detailRowComponent: 'mf-detail-row',
  gutterOpts: {
    buttons: [{
      event: 'columnChooser',
      icon: 'icon-tablecolumns',
      isLine: true,
      tooltip: 'Customise Columns',
    }],
  },
  toolBar: {
    // name: for drop down label, label: for action button label
    hideSearchBar: false, // by default let the search bar be available for the table
    buttons: [],
  },
  fields: [
    {
      title: 'Order Name',
      name: 'field-generic-input',
      sortField: 'name',
      prop: 'name',
      width: '400px',
      sticky: true,
      id: 'name',
      defaultVisible: true,
      alwaysVisible: true,
      isClickable: true,
      eventType: 'openCard',
      searchField: false, // to give a search bar for the field
      searchable: true, // to place any custom field in the header of the column like for below
      inputProps: {
        type: 'text',
      },
    }, {
      title: 'Project',
      name: 'field-generic-input',
      prop: 'project.name',
      sortField: 'project',
      searchable: true,
      filterText: 'Projects',
      width: '296px',
      id: 'project',
      isDisabled: true,
      defaultVisible: true,
      alwaysVisible: false,
    }, {
      title: 'Modified',
      name: 'dateOfChange',
      id: 'date',
      defaultVisible: true,
      alwaysVisible: false,
      width: '112px',
      searchable: true,
    }, {
      title: 'Order Type',
      name: 'module',
      width: '196px',
      prop: 'module',
      id: 'module',
      filterText: 'Order Type',
      sortField: 'module.value',
      searchable: true,
      defaultVisible: true,
      alwaysVisible: false,
    }, {
      name: 'oldOwner',
      title: 'Old Owner',
      defaultVisible: true,
      alwaysVisible: false,
      width: '296px',
      id: 'oldOwner',
      searchable: true,
    }, {
      name: 'newOwner',
      title: 'New Owner',
      width: '296px',
      id: 'newOwner',
      defaultVisible: true,
      alwaysVisible: false,
      searchable: true,
    },
    {
      title: 'Actions',
      name: 'table-field-actions',
      id: 'action',
      width: '112px',
      thAttrs: () => ({ class: 'action-sticky' }),
      tdClass: 'action-sticky',
      noRequiredCheck: true,
      sticky: true,
      hideFromChooser: true,
      alwaysVisible: true,
      searchable: true,
      clearBtn: true,
      inputProps: {
        showEdit: true,
      },
    },
  ],
};
